export default "__VITE_ASSET__877287b4__"